// Kiểu trả về chung cho MỌI hàm gọi Supabase (SKILL.md §2 — src/api/).
export type KetQua<T> = { ok: true; data: T } | { ok: false; error: string };

export function thanhCong<T>(data: T): KetQua<T> {
  return { ok: true, data };
}

export function thatBai<T = never>(error: unknown): KetQua<T> {
  const msg = error instanceof Error ? error.message : String(error);
  return { ok: false, error: msg };
}
